'use client';

import { useParams } from 'next/navigation';
import React, { FC, useState } from 'react';

import { BlogType } from '@/api/config/types';
import GlobalService from '@/api/services/GlobalService';
import { ListResponse } from '@/api/types';
import Pagination from '@/components/Pagination';
import { useTranslation } from '@/hooks/useTranslations';

import BlogItem from './BlogItem';
import BlogList from './BlogList';
import './styles.scss';

interface BlogProps {
  title?: string;
  limit?: number;
  isNewsPage?: boolean;
  exploreMore?: boolean;
  innerClassName?: string;
  hidePagination?: boolean;
  blogList: ListResponse<BlogType>;
}

const Blog: FC<BlogProps> = ({
  limit,
  blogList,
  exploreMore,
  title = 'Header-Menu-Blog',
  hidePagination,
  isNewsPage,
}) => {
  const [blogData, setBlogData] = useState(blogList.query);

  const params = useParams();
  const { t } = useTranslation();

  const onPageChange = async (page: number) => {
    return await GlobalService.getData<BlogType>('NEWS_URL_FRONT', {
      page,
      type: 2,
      perPage: 9,
      category: '',
      lang: params.lang,
    }).then((response) => setBlogData(response.query));
  };

  return (
    <div className="new-section-container-holder" id="news">
      <div className="bigContent">
        <div className={'newsBigContWrp'}>
          <div className="news-wrapper">
            <div className="news-title">
              {isNewsPage ? (
                <h1 className="newsTitleText">{t(title)}</h1>
              ) : (
                <h2 className="newsTitleText">{t(title)}</h2>
              )}
            </div>
            {exploreMore && (
              <div className="news-button-cont">
                <div className="news-button-row">
                  {/*<Link*/}
                  {/*  href={NEWS_ROUTE.getPath(params.lang as string)}*/}
                  {/*  className="button btnTypeMedium btnTypeGray"*/}
                  {/*>*/}
                  {/*  <p className="mobBtnTxt">{t('Explore more-Button')}</p>*/}
                  {/*  <i className="bc-i-go-to btnIcon btnIconSmall" />*/}
                  {/*</Link>*/}
                </div>
              </div>
            )}
            <BlogList>
              {blogData
                ?.slice(0, limit)
                .map((item) => <BlogItem {...item} logo={item.thumbnails} key={item.id} />)}
            </BlogList>
          </div>
          {hidePagination && (
            <Pagination
              pageSize={9}
              hideOnSinglePage={true}
              onChange={onPageChange}
              total={blogList.totalCount}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Blog;
